(function() {
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('product-card__atc-form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = form.querySelector('input[name="id"]').value;
    var button = form.querySelector('button[type="submit"]');
    var originalText = button.textContent.trim();
    button.textContent = 'Adding...';
    button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function() {
      button.textContent = 'Added!';
      setTimeout(function() { button.textContent = originalText; button.disabled = false; }, 2000);
      document.dispatchEvent(new CustomEvent('cart:build'));
      setTimeout(function() {
        var drawerBtn = document.querySelector('.js-drawer-open-cart');
        if (drawerBtn) drawerBtn.click();
      }, 500);
    })
    .catch(function(err) {
      button.textContent = 'Error - Try again';
      setTimeout(function() { button.textContent = originalText; button.disabled = false; }, 2000);
    });
  }, true);

        // Prevent Enter key in cart qty inputs from navigating to cart page
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (!input.matches('.cart__qty-input, [name="updates[]"], .js-qty__num')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var newQty = parseInt(input.value);
    if (isNaN(newQty) || newQty < 0) return;

    // Build updates from ALL qty inputs in the form to preserve other line items
    var form = input.closest('form');
    if (!form) return;

    var inputs = form.querySelectorAll('[name="updates[]"]');
    var updates = {};
    inputs.forEach(function(inp) {
      // Use the matching id input to get the variant/line key
      var id = inp.dataset.id || inp.closest('[data-id]') && inp.closest('[data-id]').dataset.id;
      if (id) {
        updates[id] = parseInt(inp.value);
      }
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function() {
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }, true);
})();
